import { ButtonHTMLAttributes } from 'react';

import {
  IconWrapper,
  IconContainer,
  NavigationButtonPrevious,
} from './NavigationButtons.styles';

type ArrowProps = {
  arrowColor: string;
  hideArrowsIfCantScroll?: boolean;
  currentSlide?: number;
  slideCount?: number;
};

function PrevArrowButton({
  arrowColor,
  currentSlide,
  slideCount,
  hideArrowsIfCantScroll,
  ...props
}: ArrowProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'css'>): JSX.Element {
  if (hideArrowsIfCantScroll && currentSlide + 1 === 1) return null;

  return (
    <NavigationButtonPrevious {...props}>
      <IconWrapper>
        <IconContainer color={arrowColor}>
          <svg
            viewBox="0 0 17 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.664.192a.688.688 0 010 .924l-15.191 16.3L16.82 33.882a.688.688 0 010 .925.58.58 0 01-.862 0L.213 17.913a.688.688 0 01-.034-.959L15.802.192a.58.58 0 01.862 0z"
              fill="currentColor"
            />
          </svg>
        </IconContainer>
      </IconWrapper>
    </NavigationButtonPrevious>
  );
}

export default PrevArrowButton;
